import {ILivenessValidation, IValidation, ValidationType} from '@core/api/data-access';

import {ValidationModel} from '../validation.abstract.model';

// Liveness
export class LivenessValidationModel extends ValidationModel implements ILivenessValidation {
	originalInstance: IValidation;
	public ordinal = NaN;
	public readonly type = ValidationType.Liveness;
	public passive: boolean | undefined = undefined;

	constructor() {
		super();
	}

	override asLiveness(): LivenessValidationModel {
		return this;
	}

	isValid(): boolean {
		return !isNaN(this.ordinal);
	}

	toJSON(): ILivenessValidation {
		return {
			ordinal: this.ordinal,
			type: ValidationType.Liveness,
			passive: this.passive || undefined,
		};
	}

	toObject(): ILivenessValidation {
		return this.toJSON();
	}
}
